<template>
  <div bread-crumb>
    <div class="wrapper">
      <p><router-link to="/">Home</router-link></p>
      <template v-if="false">
        <drop-select :list="struct[0]" :value="depth0" @input="goLink" />
        <drop-select :list="struct[1]" v-if="struct[1]" :value="depth1" @input="goLink" />
      </template>
    </div>
  </div>
</template>

<style lang="less">
 @import "../../../less/proj";

  [bread-crumb] { .h(49); .-b(@c-border);
    .wrapper { .ib-list; }
    p { .ir; .-h(@c-border); .wh(60,49); .bg('@{common}/ico-home.png'); .bg-c; .no-repeat; }
    [drop-select] { .-r(@c-border); background:#fff;
      .item { .h(48); .fs(15); .lh(49); .w(208); .p(0,15); .-box; }
      &.open .item { z-index: 2; }
      &:last-child label.item, .item[selected] { color:#d70539; &:after { .bg('@{common}/arrow-down-b.png'); } }
    }
  }
</style>

<script>
import DropSelect from '../../components/DropSelect.vue';
import struct from '../struct';

export default {
  name: 'BreadCrumb',
  components: { DropSelect },
  props: {
    type: { type: String, default: null },
    title: { type: String, default: null },
  },
  data() {
    return {
      struct: [],
      depth0: null,
      depth1: null,
      depth2: null,
      depth3: null,
    };
  },
  methods: {
    match(agg, data, depth) {
      const path = this.$route.path.replace(/^\/[^/]+/, '');
      let ret = false;
      _.forEach(data, (e) => {
        if (!e.children && path.match(e.value)) {
          this[`depth${depth}`] = e.value;
          ret = true;
        } else if (e.children && this.match(agg, e.children, depth + 1)) {
          this[`depth${depth}`] = e.value;
          agg[depth + 1] = e.children;
          ret = true;
        }
      });
      return ret;
    },
    goLink(to) {
      this.$router.push(to);
    },
  },
  mounted() {
    const agg = [struct];
    this.match(agg, struct, 0);
    this.struct = agg;
  },
};
</script>



// WEBPACK FOOTER //
// src/views/front/component/BreadCrumb.vue